<template>
  <div>
    <div class="news-wrap">
      <div class="news-title">{{title || $t("message.msg30")}}</div>
      <img
        class="banner"
        v-if="categories && categories.more && categories.more.thumbnail"
        :src="categories && categories.more &&categories.more.thumbnail"
        srcset
      />
      <!-- <img class="banner" v-else src="../assets/img_banner_news_en.png" srcset /> -->
    </div>
    <div class="lists w1200">
      <Row>
        <Col :xs="24" :md="24" v-for="item in lists" :key="item.id">
          <div class="list-wrap">
            <!-- <a class="list" :href="imgUrl + item.file_path"> -->
            <div class="list" @click="goNewsDetail(item.id)">
              <img :src="item.thumbnail" />
              <div class="list-detail">
                <div class="list-time">{{item.published_time.substr(0,10)}}</div>
                <div class="list-title">{{item.post_title}}</div>
                <div class="list-des">{{item.post_keywords}}</div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div style="text-align:center;margin-top:36px" v-if="lists.length >=6 && !isTotal">
      <div
        class="btn-more"
        @click="getlists"
      >{{isLoading ? $t("message.msg40") : $t("message.msg41")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabledownload",
  components: {},
  mounted() {},
  data() {
    return {
      isTotal:false,
      isLoading: false,
      lists: [],
      page: 1,
      title: "",
      categories: ""
    };
  },
  mounted() {
    this.title = this.$route.query.name || "";
    this.getlists();
    this.getCategory();
  },
  methods: {
    //分类图片
    getCategory() {
      let self = this;
      let id = this.$route.query.id || (this.$i18n.locale == "en" ? 26 : 6);
      this.$axios
        .get(
          `/api/portal/categories/${id}&lang=${this.$i18n.locale}&relation=categories`
        )
        .then(function(res) {
          console.log(res);
          self.categories = res.data.data;
        });
    },
    //文章
    getlists() {
      let self = this;
      this.isLoading = true;
      let id = this.$route.query.id || (this.$i18n.locale == "en" ? 23 : 20);
      this.$axios
        .get(
          `/api/portal/lists/getCategoryPostLists?category_id=${id}&page=${this.page}&listRows=6&lang=${this.$i18n.locale}`
        )
        .then(function(res) {
          console.log(res);
          if (res.data.data.list.length > 0) {
            self.lists = self.lists.concat(res.data.data.list);
            self.page++;
          }else {
              self.isTotal = true;
            }
          self.isLoading = false;
        });
    },
    //文章详情
    goNewsDetail(id) {
      this.$router.push("/newsdetail?id=" + id);
    }
  },
  watch: {
    "$i18n.locale"() {
      this.lists = [];
      this.page = 1;
      this.getlists();
    },
    "$route.query.id"() {
      this.page = 1;
      this.lists = [];
      this.getlists();
    },
    "$route.query.name"() {
      this.title = this.$route.query.name;
    }
  }
};
</script>
<style lang="scss" scoped>
.news-wrap {
  width: 100%;
  height: 300px;
  overflow: hidden;
  position: relative;
  margin-bottom: 36px;
  .news-title {
    font-size: 44px;
    font-weight: 500;
    color: rgba(0, 35, 60, 1);
    line-height: 78px;
    margin-top: 90px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    z-index: 9;
  }
  .banner {
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    height: 300px;
    min-width: 100%;
  }
}
.list-wrap {
  overflow: hidden;
}

.list {
  overflow: hidden;
  box-sizing: border-box;
  padding: 32px 16px;
  background: #fff;
  border-bottom: 1px solid rgba(0, 35, 60, 0.48);
  img {
    float: left;
    width: 272px;
    height: 132px;
  }
  .list-detail {
    margin-left: 300px;
  }
  .list-time {
    float: right;
    font-size: 24px;
    font-weight: 300;
    color: rgba(0, 35, 60, 0.48);
    line-height: 29px;
  }
  .list-title {
    margin: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 24px;
    font-weight: 500;
    color: rgba(0, 35, 60, 1);
    line-height: 33px;
  }
  .list-des {
    font-size: 16px;
    height: 48px;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 16px;
    font-weight: 400;
    color: rgba(0, 35, 60, 0.48);
    line-height: 24px;
    text-shadow: 0px 16px 32px rgba(0, 43, 85, 0.04);
  }
}
.list-more {
  margin-left: 16px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(67, 176, 212, 1);
  line-height: 22px;
  text-shadow: 0px 16px 32px rgba(0, 43, 85, 0.04);
  text-decoration: underline;
}
.btn-more {
  margin-bottom: 36px;
}
@media (max-width: 768px) {
  .news-wrap {
    margin-bottom: 0px;
    .news-title {
      font-size: 30px;
    }
  }
  .sections {
    padding-bottom: 30px;
  }
  .list {
    padding: 4px;
    .list-detail {
      margin-left: 170px;
    }
    .list-title {
      margin: 0px;
      font-size: 16px;
    }
    .list-time {
      font-size: 16px;
      line-height: 33px;
    }
    .list-des {
      font-size: 14px;
      padding: 0px;
    }
    img {
      width: 156px;
      height: 80px;
    }
    .section-title {
      font-size: 20px;
      margin: 0px 16px;
    }
  }
}
</style>